export const accommodationfilterTableItemContentMotion = {
    initial: { opacity: 0 },
    animate: {
        opacity: [0, 1],
        transition: {
            duration: 0.3,
            ease: 'easeIn',
        },
    },
};
